<template>
  <div class="sort_type">
    <div>
      <el-select v-model="bedTypeId" :placeholder="title" @change="clickItem" :style="'width:' + width + 'px'" clearable>
        <el-option v-for="(item, index) in sortList" :key="index" :label="item.name" :value="item.value"/>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sortList: {
      type: Array,
      default: []
    },
    title: String,
    width: Number
  },
  data () {
    return {
      selectIndex: null,
      bedTypeId: ''
    }
  },
  methods: {
    clickItem (e) {
      this.$emit('updateSelect', e)
    },
    clearVal () {
      this.bedTypeId = ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.sort_type {
  font-size: 14px;

  & >>> .el-select .el-input {
    min-width: auto !important;
    width: auto !important;
  }

  & >>> .el-input__inner {
    border: none;
    background: #f6f6f6;
    color: #000;
    font-weight: bolder;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    &::placeholder {
      color: #000;
      font-weight: bolder;
    }
  }

  & >>> .el-input__inner:focus {
    border: none !important;
    box-shadow: none !important;
  }

  & >>> .el-input__suffix {
    & .el-select__caret.el-input__icon {
      color: #000 !important;
      font-weight: bolder;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/RadioSpan.vue